import { Component, Input } from '@angular/core';
import { FretDiagram } from '../../models/guitar-lesson.model';

const STRING_LABELS = ['E', 'B', 'G', 'D', 'A', 'E']; // high E → low E

@Component({
  selector: 'app-fret-diagram',
  templateUrl: './fret-diagram.component.html',
  styleUrls: ['./fret-diagram.component.scss'],
  standalone: false,
})
export class FretDiagramComponent {
  @Input() diagram!: FretDiagram;

  stringLabels = STRING_LABELS;

  get minFret(): number {
    return this.diagram?.minFret ?? 0;
  }

  get fretColumns(): number[] {
    const start = this.minFret;
    return [start, start + 1, start + 2, start + 3, start + 4];
  }

  marker(stringIdx: number): string {
    const f = this.diagram.frets[stringIdx];
    if (f === null || f === undefined) return 'x';
    if (f === 0) return 'o';
    return '';
  }

  hasDot(stringIdx: number, fret: number): boolean {
    return this.diagram.frets[stringIdx] === fret && fret > 0;
  }

  label(stringIdx: number): string | null {
    return this.diagram.labels?.[stringIdx] ?? null;
  }
}
